import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const METADATA_GET = createApiNamespacedConstants('METADATA_GET');
export const METADATA_PUT = createApiNamespacedConstants('METADATA_PUT');
export const INITIAL_DATA = createApiNamespacedConstants('INITIAL_DATA');

export const MOBILE_DEVICE_ANIMATIONS_TOGGLE = createApiNamespacedConstants('MOBILE_DEVICE_ANIMATIONS_TOGGLE');
export const MOBILE_DEVICE_APP_RESTART = createApiNamespacedConstants('MOBILE_DEVICE_APP_RESTART');
export const MOBILE_SESSION_APP_INFO_FETCH = createApiNamespacedConstants('MOBILE_SESSION_APP_INFO_FETCH');
export const MOBILE_DEVICE_CONNECT = createApiNamespacedConstants('MOBILE_DEVICE_CONNECT');
export const MOBILE_DEVICE_LANGUAGES_FETCH = createApiNamespacedConstants('MOBILE_DEVICE_LANGUAGES_FETCH');
export const MOBILE_DEVICE_LANGUAGE_SET = createApiNamespacedConstants('MOBILE_DEVICE_LANGUAGE_SET');
export const MOBILE_DEVICE_HARDWARE_BUTTON_PRESS = createApiNamespacedConstants('MOBILE_DEVICE_HARDWARE_BUTTON_PRESS');
export const MOBILE_DEVICE_ROTATE = createApiNamespacedConstants('MOBILE_DEVICE_ROTATE');
export const MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION = createApiNamespacedConstants('MOBILE_DEVICE_BIOMETRICS_AUTHENTICATION');
export const MOBILE_DEVICE_INJECT_IMAGE = createApiNamespacedConstants('MOBILE_DEVICE_INJECT_IMAGE');
export const MOBILE_DEVICE_SHARE_SESSION = createApiNamespacedConstants('MOBILE_DEVICE_SHARE_SESSION');
export const MOBILE_DEVICE_STATE_UPDATE = `${NAMESPACE}/MOBILE_DEVICE_STATE_UPDATE`;
export const MOBILE_DEVICE_ERROR_OVERLAY_DISMISS = `${NAMESPACE}/MOBILE_DEVICE_ERROR_OVERLAY_DISMISS`;
export const MOBILE_DEVICE_APP_INSTALL = createApiNamespacedConstants('MOBILE_DEVICE_APP_INSTALL');
export const MOBILE_DEVICE_TAKE_SCREENSHOT = createApiNamespacedConstants('MOBILE_DEVICE_TAKE_SCREENSHOT');
export const MOBILE_DEVICE_WIFI_TOGGLE = createApiNamespacedConstants('MOBILE_DEVICE_WIFI_TOGGLE');
export const MOBILE_DEVICE_FETCH = createApiNamespacedConstants('MOBILE_DEVICE_FETCH');
export const MOBILE_SESSION_CREATE = createApiNamespacedConstants('MOBILE_SESSION_CREATE');
export const MOBILE_SESSION_STOP = createApiNamespacedConstants('MOBILE_SESSION_STOP');
export const MOBILE_DEVICE_OPEN_URL = createApiNamespacedConstants('MOBILE_DEVICE_OPEN_URL');
export const MOBILE_DEVICE_PASTE_CONTENT = createApiNamespacedConstants('MOBILE_DEVICE_PASTE_CONTENT');
export const MOBILE_DEVICE_EXECUTE_ADB_SHELL = createApiNamespacedConstants('MOBILE_DEVICE_EXECUTE_ADB_SHELL');
export const MOBILE_DEVICES_FACETS_CLEANUP = `${NAMESPACE}/MOBILE_DEVICES_FACETS_CLEANUP`;
export const MOBILE_DEVICES_PERFORMANCE_MODE_SET = `${NAMESPACE}/MOBILE_DEVICES_PERFORMANCE_MODE_SET`;
export const TOGGLE_WEBRTC__AUDIO = `${NAMESPACE}/TOGGLE_WEBRTC__AUDIO`;
